import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bc670b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dialog"
}
const _hoisted_2 = { class: "dialog__body" }
const _hoisted_3 = { class: "file-total" }
const _hoisted_4 = {
  key: 0,
  class: "file-pop-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilePopItem = _resolveComponent("FilePopItem")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "mask" }, {
      default: _withCtx(() => [
        (_ctx.visible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cover",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "pop" }, {
      default: _withCtx(() => [
        (_ctx.visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("a", {
                href: "javascript:;",
                class: "qh-icon-close",
                title: "关闭",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.name), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, " 已下载" + _toDisplayString(`${_ctx.totalDownloaded}项(共${_ctx.totalFileNums}项)`), 1),
                  (_ctx.hasContinueAddTaskBtn)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleOnContinueAddTask && _ctx.handleOnContinueAddTask(...args)))
                      }, "继续添加"))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (id) => {
                        return (_openBlock(), _createBlock(_component_FilePopItem, {
                          id: id,
                          key: id
                        }, null, 8, ["id"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_component_Loading, { key: 1 }))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}